const ITEMS = [
  "★ KUKI IMPRESIONES",
  "• ÚTILES ESCOLARES Y DE OFICINA",
  "★ AGENDAS PERSONALIZADAS",
  "• NOVEDADES & REGALOS",
  "★ PAPELERÍA CREATIVA & STICKERS",
  "• PEDIDOS AL WHATSAPP 0994 945 144",
  "★ ENVÍOS A TODO EL PAÍS",
  "• SEÑA DEL 50% PARA APARTAR",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="bg-kyellow border-y-2 border-ink overflow-hidden py-3.5 select-none" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="font-display font-bold text-lg tracking-wide px-6">{item}</span>
        ))}
      </div>
    </div>
  );
}
